'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _formInputField = _interopRequireDefault(require("../form-input-field"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var generateProjectFilterFromProjectRegistrations = function generateProjectFilterFromProjectRegistrations(registrations, translate) {
  return registrations.reduce(function (filterList, registration) {
    if (filterList.indexOf(registration.project_key) === -1) filterList.push(registration.project_key);
    return filterList;
  }, []).map(function (id) {
    return {
      id: id,
      name: translate(id)
    };
  });
};

var generateCantonFilterFromProjectRegistrations = function generateCantonFilterFromProjectRegistrations(registrations, cantons) {
  return registrations.reduce(function (filterList, registrations) {
    if (filterList.indexOf(registrations.canton_id) === -1) filterList.push(registrations.canton_id);
    return filterList;
  }, []).map(function (id) {
    var canton = cantons.reduce(function (result, canton) {
      if (canton.id === id) return canton;
      return result;
    }, {});
    return {
      id: id,
      name: canton.name || '-'
    };
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
};

var filteredProjects = function filteredProjects(projects, filter) {
  return projects.filter(function (entry) {
    if (filter.canton_id && parseInt(entry.canton_id) !== parseInt(filter.canton_id)) return false;
    if (filter.mainlanguage && parseInt(entry.mainlanguage) !== parseInt(filter.mainlanguage)) return false;
    if (filter.status && entry.status !== filter.status) return false;
    if (filter.project_key && entry.project_key !== filter.project_key) return false;
    return true;
  });
};

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
    _this.renderDetailLink = _this.renderDetailLink.bind(_assertThisInitialized(_this));
    _this.state = {
      isLoading: false,
      projectsNotFound: false,
      projects: [],
      filters: {
        canton_id: '',
        status: '',
        mainlanguage: '',
        project_key: ''
      },
      filtersLocal: {
        canton_id: '',
        status: '',
        mainlanguage: '',
        project_key: ''
      },
      cantonList: [],
      mainLanguageList: [],
      projectList: []
    };
    _this.onDropDownChange = _this.onDropDownChange.bind(_assertThisInitialized(_this));
    _this.loadProjects = _this.loadProjects.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n;

      if (!i18n.isInitialized) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      if (this.state.isLoading) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      var columns = [{
        title: '',
        render: this.renderDetailLink
      }, {
        title: t('project name'),
        render: function render(val, row) {
          return t(row.project_key);
        },
        prop: 'project_key'
      }, {
        title: t('status'),
        render: function render(val, row) {
          return t(row.status);
        },
        prop: 'status'
      }, {
        title: t('farm name'),
        prop: 'farmname'
      }, {
        title: t('first name'),
        prop: 'first_name'
      }, {
        title: t('last name'),
        prop: 'last_name'
      }, {
        title: t('username'),
        prop: 'username'
      }, {
        title: t('zip'),
        prop: 'zip'
      }, {
        title: t('city'),
        prop: 'city'
      }, {
        title: t('canton'),
        render: function render(val, row) {
          var canton = _lodash.default.find(_this2.state.cantonList, {
            id: parseInt(row.canton_id)
          });

          return canton != null ? canton.name : '';
        }
      }, {
        title: t('main language'),
        render: function render(val, row) {
          var mainLanguage = _lodash.default.find(_this2.state.mainLanguageList, {
            id: parseInt(row.mainlanguage)
          });

          return mainLanguage != null ? mainLanguage.name : '';
        }
      }];
      var staticTexts = {
        search: t('search'),
        noData: t('no data'),
        loading: t('loading data'),
        all: t('all'),
        pageSize: t('results per page')
      };
      var statusList = [{
        id: 'open',
        name: t('Open')
      }, {
        id: 'requesttopublish',
        name: t('requesttopublish')
      }, {
        id: 'checked',
        name: t('Checked')
      }, {
        id: 'released',
        name: t('Released')
      }];
      var showProjectFilter = this.state.projectList.length > 1,
          showCantonFilter = this.state.cantonList.length > 1;
      var filterGridClassName = 'medium-6'; // default none is set

      if (showProjectFilter || showCantonFilter) {
        filterGridClassName = 'medium-4'; // update if one of them is set
      }

      if (showProjectFilter && showCantonFilter) {
        filterGridClassName = 'medium-3'; // update if both are set
      }

      var table = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, showCantonFilter && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 ".concat(filterGridClassName)
      }, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        isEditable: true,
        name: 'canton_id',
        label: t('canton'),
        onChange: this.onDropDownChange,
        type: _formInputField.default.component.constants.SINGLE_SELECT,
        list: this.state.cantonList,
        value: localStorage.canton_id ? localStorage.canton_id : this.state.filters.canton_id,
        allowAll: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 ".concat(filterGridClassName)
      }, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        isEditable: true,
        name: 'status',
        label: t('status'),
        onChange: this.onDropDownChange,
        type: _formInputField.default.component.constants.SINGLE_SELECT,
        list: statusList,
        value: localStorage.status ? localStorage.status : this.state.filters.status,
        allowAll: true
      })), showProjectFilter && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 ".concat(filterGridClassName)
      }, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        isEditable: true,
        name: 'project_key',
        label: t('project'),
        onChange: this.onDropDownChange,
        type: _formInputField.default.component.constants.SINGLE_SELECT,
        list: this.state.projectList,
        value: localStorage.project_key ? localStorage.project_key : this.state.filters.project_key,
        allowAll: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 ".concat(filterGridClassName)
      }, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        isEditable: true,
        name: 'mainlanguage',
        label: t('main language'),
        onChange: this.onDropDownChange,
        type: _formInputField.default.component.constants.SINGLE_SELECT,
        list: this.state.mainLanguageList,
        value: localStorage.mainlanguage ? localStorage.mainlanguage : this.state.filters.mainlanguage,
        allowAll: true
      }))), /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id', t('project_key')],
        columns: columns,
        initialData: filteredProjects(this.state.projects, this.state.filtersLocal),
        initialPageLength: 10,
        staticTexts: staticTexts,
        isLoading: this.state.isLoading,
        initialSortBy: {
          prop: 'farmname',
          order: 'descending'
        },
        useLocalStorage: true
      }));

      if (this.state.projectsNotFound) table = /*#__PURE__*/_react.default.createElement("p", null, t('no project registrations'));
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, t('project overview')), table);
    }
  }, {
    key: "renderDetailLink",
    value: function renderDetailLink(val, row) {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: "".concat(row.project_key, "-release/").concat(row.farm_id),
        title: t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      this.setState({
        isLoading: true
      });
      this.setState(function (prev) {
        prev.filtersLocal.status = localStorage.status;
        prev.filtersLocal.canton_id = localStorage.canton_id;
        prev.filtersLocal.mainlanguage = localStorage.mainlanguage;
        prev.filtersLocal.project_key = localStorage.project_key;
        return prev;
      });

      var loadRelatedDataCollection = function loadRelatedDataCollection(url, name, cb) {
        // Load categories and subcategories
        return fetch(url, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (objects) {
          _this3.setState(function (prev) {
            prev[name] = objects;
            return prev;
          }, cb);
        }).catch(console.error);
      };

      loadRelatedDataCollection(_conf.default.api.correspondenceLanguageApiUrlTemplate(this.props.i18n.language), 'mainLanguageList');
      loadRelatedDataCollection(_conf.default.api.cantonApiUrlTemplate(this.props.i18n.language), 'cantonList', this.loadProjects);
    }
  }, {
    key: "loadProjects",
    value: function loadProjects() {
      var _this4 = this;

      var projectUrl = _conf.default.api.projectsRegistrations(this.props.i18n.language);

      fetch(projectUrl, {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (results) {
        _this4.setState(function (prev) {
          prev.projects = results;
          prev.isLoading = false;
          prev.projectList = generateProjectFilterFromProjectRegistrations(results, _this4.props.t);
          prev.cantonList = generateCantonFilterFromProjectRegistrations(results, prev.cantonList);
          return prev;
        });
      }).catch(function () {
        _this4.setState(function (prev) {
          prev.projectsNotFound = true;
          prev.isLoading = false;
          return prev;
        });
      });
    }
  }, {
    key: "onDropDownChange",
    value: function onDropDownChange(event) {
      var target = event.target;
      var name = target.name;
      var filterValue = target.value || '';
      localStorage.setItem(target.name, target.value); // evil hack (updating an information of antoher component),
      // but yet not otherwise possible

      localStorage.setItem('dataListCurrentPageNumber', '0');
      this.setState(function (prevState) {
        prevState.filters[name] = filterValue;
        prevState.filtersLocal[name] = localStorage[name];
        return prevState;
      });
    }
  }]);

  return Table;
}(_react.default.Component);

Table.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    isInitialized: _propTypes.default.bool
  })
};

var _default = (0, _translate.default)(Table);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-list/index.js
// module id = 727
// module chunks = 0